import { AggregationErrorType, AggregationType } from "../../models/AggregationType";
import { ConsentType } from "../../models/ConsentType";
import { ProviderList } from "../../models/ProviderType";
import { RequestType } from "../../models/RequestType";
import { axiosInstance as Api } from "../../utils/apiHelper";

const BASE_URL = process.env.REACT_APP_BASE_URL_API + '/api-bankreader/v2';
const API_BANKREADER = "/bankreaders";

export const BankreaderService = {
  getBankConfig: (bankreaderId: string): Promise<RequestType> => {
    return Api.get(BASE_URL + API_BANKREADER + `/${bankreaderId}`);
  },

  getConsent: (bankreaderId: string, consentData: ConsentType) => {
    return Api.post(BASE_URL + API_BANKREADER + `/${bankreaderId}/consents`,
    consentData 
    );
  },

  getProviders: (thirdParty?: string): Promise<ProviderList> => {
    return Api.get(BASE_URL + `/providers?third_party=${thirdParty}`);
  },

  sendWebsocketCode: (bankreaderId: string, codeMessage: {code: string}) => {
    return Api.post(
      BASE_URL + API_BANKREADER + `/${bankreaderId}/websocket`,
      codeMessage
    );
  },

  handleAggregation: (bankreaderId: string, aggregation: AggregationType) => {
    return Api.post(
      BASE_URL + API_BANKREADER + `/${bankreaderId}/aggregations`,
      aggregation
    );
  },
  handleAggregationError: (bankreaderId: string, aggregationError: AggregationErrorType) => {
    return Api.post(
      BASE_URL + API_BANKREADER + `/${bankreaderId}/aggregations-errors`,
      aggregationError
    );
  },
};
